import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useGetDlMutation } from '../../api/FakturaAPI';
import { formatToEuroDate } from '../../util/DateUtils';
import Footer from '../footer/Footer';
import LandingpageHeader from '../header/LandingpageHeader';

export default function AbrechenbareDl() {

    type satz = {
        text: string,
        erledigtAm: Date,
        auftraggeber: {
            name: string,
        },
        preis: number
    }

    //const dispatch = useDispatch<AppDispatch>();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [getDl] = useGetDlMutation();
    const [auftraege, setAuftraege] = useState<satz[]>([]);

    const lade = () => {

        getDl().unwrap()
            .then((data) => setAuftraege(data));

    }

    useEffect(() => {
        lade();
    }, []);

    return (
        <>
            <div>

                <LandingpageHeader />

                <div style={{ padding: "20px" }}>

                    <div className="container">
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <button
                                onClick={() => {
                                    navigate({
                                        pathname: "/",
                                        search: ""
                                    });
                                }}

                                style={{ marginBottom: "20px" }}
                                className=' btn btn-outline-primary'
                            >
                                <i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
                            </button>
                        </div>
                        
                        <h3>Abrechenbare Dienstleistungen</h3>

                        <p>
                            Anzahl {auftraege.length}
                        </p>

                        <table className="table">

                            <tr>
                                <th>Text</th>
                                <th>Preis</th>
                                <th>Erledigtdatum</th>
                                <th>Rechnungsempfänger</th>
                            </tr>

                            {auftraege.map((e, index) => <>
                                <tr key={index}>
                                    <td>{e.text}</td>
                                    <td>{e.preis}</td>
                                    <td>{formatToEuroDate(e.erledigtAm)}</td>
                                    <td>{e.auftraggeber.name}</td>
                                </tr>
                            </>)}

                        </table >

                    </div>
                </div>
            </div >
            <Footer />
        </>
    );
}
